import { setFirebaseApp } from 'core/store/app/actions'
import { initializeApp } from 'firebase/app'
import { ApplicationState } from 'core/store/reducers'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const useFirebase = () => {
    const dispatch = useDispatch()
    const { firebaseApp } = useSelector(({ app }: ApplicationState) => ({
        firebaseApp: app.firebaseApp,
    }))
    const [hasRun, setHasRun] = useState(firebaseApp !== undefined)

    useEffect(() => {
        if (!hasRun && !firebaseApp) {
            setHasRun(true)
            const firebaseConfig = {
                apiKey: 'AIzaSyDRXU-Dz1NcifBH2kvDDAik701FjF-7Ocw',
                authDomain: 'ardoises-1b5ee.firebaseapp.com',
                databaseURL: 'https://ardoises-1b5ee.firebaseio.com',
                projectId: 'ardoises-1b5ee',
                storageBucket: 'ardoises-1b5ee.firebasestorage.app',
                messagingSenderId: '284921710691',
                appId: '1:284921710691:web:c00a1e1700511e87af9056',
                measurementId: 'G-9FTDTG1CGD',
            }
            try {
                const app = initializeApp(firebaseConfig)
                dispatch(setFirebaseApp(app))
            } catch (error) {
                console.error("Erreur lors de l'initialisation Firebase:", error)
            }
        }
    }, [firebaseApp, dispatch, hasRun])

    return firebaseApp
}

export default useFirebase
